import { usePageMeta } from '@/hooks/usePageMeta';
import { useLocation } from 'react-router-dom';
import ScheduleHeader from './components/ScheduleHeader';
import ScheduleList from './components/ScheduleList';

export default function Schedule() {
  const location = useLocation();

  usePageMeta(
    'Schedule | Keaton Brown — Upcoming & Past Performances',
    'View Keaton Brown\'s upcoming and past performance schedule. Recent engagements include Opera North, HOPERA, Apollo Chamber Players, Bach Society Houston, and Nashville Opera. Based in Houston, Texas.'
  );

  return (
    <main>
      <ScheduleHeader />
      <ScheduleList />
    </main>
  );
}